<template>

  <v-card>
    <v-card-title>
      <span class="body-2">Relação de configurações para integração</span>
      <v-spacer></v-spacer>
      <sys-institution-pop-over-setting v-if="hasIntegration(1) && acesso && acesso.instituicao" :institution="acesso.instituicao" />
      <v-btn icon @click.prevent.stop="show = true"><v-icon>mdi-plus</v-icon></v-btn>
    </v-card-title>

    <emcTableItems
        :headers="headers"
        v-bind:collections.sync="collections"
        v-bind:meta.sync="meta"
        v-bind:itemDelete.sync="itemDelete"
        v-bind:itemEdit.sync="model"
        :find="false"
    >
      <template v-slot:[`item.last_test`]="{ item }">
        <div v-if="item.last_tested_at" class="d-flex align-center justify-center flex-nowrap">
          <v-tooltip bottom max-width="360">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  v-bind="attrs"
                  v-on="on"
                  x-small
                  dark
                  :color="item.last_test_success ? 'success' : 'error'"
              >
                <v-icon x-small left>{{ item.last_test_success ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
                {{ item.last_test_success ? 'OK' : 'Falha' }}
              </v-chip>
            </template>
            <span style="white-space: pre-line">{{ item.last_test_message }}</span>
          </v-tooltip>
          <span class="ml-2 text-caption grey--text text-no-wrap">{{ item.last_tested_at | dateTime }}</span>
        </div>
        <span v-else class="text-caption grey--text">Conexão nunca testada</span>
      </template>

      <template v-slot:actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <v-btn
                  small
                  outlined
                  color="primary"
                  class="mr-2 text-none"
                  :loading="testingId === item.id"
                  :disabled="!isTestable(item) || testingId !== null"
                  @click.prevent.stop="testConnection(item)"
              >
                <v-icon small left>mdi-connection</v-icon>
                Testar conexão
              </v-btn>
            </span>
          </template>
          <span>{{ isTestable(item) ? 'Testar conexão' : 'Teste indisponível para este tipo' }}</span>
        </v-tooltip>
      </template>
    </emcTableItems>

    <SysRegisterIntegrationParameter @onCompleted="getData()" :model="model" :show.sync="show"/>

    <emc-alert-snackbar :show="!! message.length" :message="message" :color="error ? 'error' : 'success'"/>

    <!-- Modal usado para mensagem e ação de exclusão -->
    <emc-alert-modal :text="textDelete" :disabled="deleting" v-bind:show.sync="showDelete">
      <template v-slot:actions>
        <v-btn color="error" @click.prevent.stop="deleteItem()" :loading="deleting" :disabled="deleting">Excluir <v-icon right dark>mdi-delete</v-icon></v-btn>
      </template>
    </emc-alert-modal>

  </v-card>

</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
  name: "SysInstitutionIntegration",
  props: {
    institution: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    headers: [
      { text: 'Tipo', value: 'integration.name'},
      { text: 'Ambiente', value: 'environment'},
      { text: 'Usuário', value: 'integration_username'},
      { text: 'Domínio', value: 'integration_url'},
      { text: 'Porta', value: 'integration_port'},
      { text: 'Último teste', value: 'last_test'},
      { text: 'Ações', value: 'actions'},
    ],
    collections: [],
    meta: {},
    itemDelete: {},
    model: {},
    show: false,
    showDelete: false,
    textDelete: '',
    deleting: false,
    testingId: null,
    message: '',
    error: false
  }),
  created() {
    this.getData();
  },
  computed: {
      ...mapState('auth', ['acesso'])
  },
  methods: {
    ...mapActions('institution', ['ActionShowInstitution', 'ActionDestroyIntegrationParameter', 'ActionTestIntegrationParameter']),
    isTestable(item) {
      // Fase 1: apenas Totvs SOAP (1) e Totvs RM RestDataServer (6).
      return [1, 6].includes(Number(item.integration_id))
    },
    testConnection(item) {
      this.testingId = item.id
      this.message = ''
      this.error = false

      this.ActionTestIntegrationParameter({ id: item.id })
          .then((r) => {
            const data = (r && r.data) ? r.data : {}
            const ok = !!data.success
            this.error = !ok
            this.message = data.message || (ok ? 'Conexão estabelecida com sucesso.' : 'Falha ao testar a conexão.')
          })
          .catch((e) => {
            this.error = true
            this.message = (e && e.message) ? e.message : 'Falha ao testar a conexão.'
          })
          .finally(() => {
            this.testingId = null
            // Recarrega para refletir o último resultado persistido na linha.
            this.getData()
          })
    },
    getData() {

      const params = {
        id: this.institution.id,
        with: 'integrationParameters.integration'
      }
      this.ActionShowInstitution(params)
          .then((r) => {
              this.collections = r.data.integration_parameters
              this.meta = {
                page: 1,
                itemsPerPage: 10,
                total: this.collections ? this.collections.length : 0,
                last_page: 1
              }
          })
          .finally(() => {

          })
    },
    deleteItem() {
      this.ActionDestroyIntegrationParameter({ id: this.itemDelete.id })
          .then((r) => {
            this.getData()
          })
          .finally(() => {
            this.showDelete = false
            this.textDelete = ''
          })
    }
  },
  watch: {
    model(newItem, oldItem) {
      if(newItem != oldItem && this.model.id) {
        this.show = true
      } else if(Object.keys(this.model).length === 0){
        this.show = false;
      }
    },
    show(val) {
      if(!val) {
        this.model = {}
      }
    },
    itemDelete(item_new, item_old){

      if(item_new !== item_old && Object.keys(item_new).length > 0)
      {
        this.showDelete = true;
        this.textDelete = "Deseja excluir o item " + item_new.environment + "?";
      } else {
        this.showDelete = false
        this.textDelete = '';
      }
    },
  }
}
</script>